
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile",
      function () {
        return require("private-next-pages/profile.js");
      }
    ]);
  